/*
 * AgeTargetingCard Messages
 *
 * This contains all the text for the AgeTargetingCard component.
 */
import { defineMessages } from 'react-intl';

const scope = `app.components.TargetingPeeqPage.Criteria`;

export default defineMessages({
  quotaSumError: {
    id: `${scope}.quotaSumError`,
    defaultMessage: 'The sum of the quotas must be at least {completes}',
  },
  nonBinaryNotification: {
    label: {
      id: `${scope}.nonBinaryNotification.label`,
      defaultMessage: 'Heads - Up',
    },
    description: {
      id: `${scope}.nonBinaryNotification.description`,
      defaultMessage:
        'If your survey results contain responses with <strong>"Not Specified"</strong> as a Gender, you will not be able to apply post-stratification in the results dashboard.',
    },
    footer: {
      id: `${scope}.nonBinaryNotification.footer`,
      defaultMessage:
        'The official provided statistical information about the population does not include "Not Specified" as a gender; therefore, our algorithm won\'t work.',
    },
  },
});
